import { createContext, useContext } from 'react'
import type { ContainerState } from '../hooks/useContainerSize'

// Create context with null as initial value
export const ContainerQueryContext = createContext<ContainerState | null>(null)

/**
 * Hook to access container query state from any component within ContainerRoot
 * @returns Container query state with dimensions and breakpoint information
 */
export function useContainerState(): ContainerState {
  const context = useContext(ContainerQueryContext)

  if (context === null) {
    throw new Error('useContainerState must be used within a ContainerRoot component')
  }

  return context
}
